(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[287],{

/***/ 43130:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/companies",
      function () {
        return __webpack_require__(38733);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FAQCompanies": function() { return /* binding */ FAQCompanies; },
/* harmony export */   "FAQCompaniesLayout": function() { return /* binding */ FAQCompaniesLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _platform_ui_kit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(946);
/* harmony import */ var _platform_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19767);
/* harmony import */ var _platform_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44386);
/* harmony import */ var _platform_website_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26159);
/* harmony import */ var _platform_website_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31483);
/* harmony import */ var _platform_website_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46087);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59798);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_1__);





const ACCORDION_COMPANIES_ITEMS = [
    {
        headerText: "What is Olby?",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["content-text"]),
            children: "Olby is a tech-enabled community to hire engaging talent from Brazil. We provide our talent, individually or as a team, to companies that need help scaling or leading their engineering team."
        })
    },
    {
        headerText: "How soon can Olby talent join my team? ",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["content-text"]),
            children: "This can range from a few days to a few weeks and will mostly depend on your requirements."
        })
    },
    {
        headerText: "Can I interview Olby's Talent?",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["content-text"]),
            children: "Yes. Our matching process includes at least a 30-minute call so talent and company can get to know each other. We also allow for customized multi-step interview processes. However, we encourage you to trust our vetting process and keep it simple. If the talent does not meet your expectations during the initial two weeks, you pay nothing."
        })
    },
    {
        headerText: "How do payments work?",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["content-text"]),
            children: [
                "The company pays Olby through our simple monthly billing, and Olby pays the talent. We accept Domestic and International wire transfers. Please email",
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_ui_kit__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default().link),
                    href: "mailto:".concat(_platform_utils__WEBPACK_IMPORTED_MODULE_3__/* .JUNGLE_FINANCIAL_SUPPORT_EMAIL */ .rr),
                    children: _platform_utils__WEBPACK_IMPORTED_MODULE_3__/* .JUNGLE_FINANCIAL_SUPPORT_EMAIL */ .rr
                }),
                " ",
                "for more information."
            ]
        })
    },
    {
        headerText: "Do you provide talent on part-time basis talent?",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["content-text"]),
            children: "Our talent normally join our partners on a full-time, fully dedicated basis. This being said, if you’re interested in building a long-term partnership that starts with part-time talent, we’re down to chat."
        })
    },
    {
        headerText: "How do I hire talent?",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["content-text"]),
            children: [
                "Please, visit",
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_ui_kit__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default().link),
                    href: "".concat("https://company.olby.com", "/sign-up"),
                    prefetch: false,
                    isExternal: true,
                    children: "".concat("https://company.olby.com", "/sign-up")
                }),
                " ",
                "to get started."
            ]
        })
    }
];
const FAQCompanies = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_website_components__WEBPACK_IMPORTED_MODULE_4__/* .WebsiteAccordionFAQ */ .b, {
        title: "For companies",
        content: ACCORDION_COMPANIES_ITEMS
    });
};
const getLayout = (page)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_platform_website_components__WEBPACK_IMPORTED_MODULE_5__/* .FAQLayout */ .C4, {
        children: page
    });
const FAQCompaniesLayout = (0,_platform_utils__WEBPACK_IMPORTED_MODULE_6__/* .nestLayout */ .lB)({
    parent: _platform_website_components__WEBPACK_IMPORTED_MODULE_7__/* .WebsitePageLayout */ .XN,
    child: getLayout
});
FAQCompanies.getLayout = FAQCompaniesLayout;
/* harmony default export */ __webpack_exports__["default"] = (FAQCompanies);


/***/ }),

/***/ 26159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ WebsiteAccordionFAQ; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-accordion/dist/index.module.js + 2 modules
var index_module = __webpack_require__(42691);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/ui-kit/src/lib/assets/icons/chevron-down.svg
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgChevronDown = function SvgChevronDown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgChevronDown);

/* harmony default export */ var chevron_down = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjI5Mjg5IDguMjkyODlDNS42ODM0MiA3LjkwMjM3IDYuMzE2NTggNy45MDIzNyA2LjcwNzExIDguMjkyODlMMTIgMTMuNTg1OEwxNy4yOTI5IDguMjkyODlDMTcuNjgzNCA3LjkwMjM3IDE4LjMxNjYgNy45MDIzNyAxOC43MDcxIDguMjkyODlDMTkuMDk3NiA4LjY4MzQyIDE5LjA5NzYgOS4zMTY1OCAxOC43MDcxIDkuNzA3MTFMMTIuNzA3MSAxNS43MDcxQzEyLjMxNjYgMTYuMDk3NiAxMS42ODM0IDE2LjA5NzYgMTEuMjkyOSAxNS43MDcxTDUuMjkyODkgOS43MDcxMUM0LjkwMjM3IDkuMzE2NTggNC45MDIzNyA4LjY4MzQyIDUuMjkyODkgOC4yOTI4OVoiLz4KPC9zdmc+Cg==");
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/seo/index.tsx
var seo = __webpack_require__(25352);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/frequently-asked-questions/website-accordion-faq/styles.module.scss
var styles_module = __webpack_require__(59258);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/frequently-asked-questions/website-accordion-faq/index.tsx





const SEO = {
    title: "FAQ // Olby",
    description: "Whether you have questions about hiring Olby or about applying for jobs, we have the answers for both."
};
const WebsiteAccordionFAQ = (param)=>{
    let { title , content  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                seo: SEO
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (styles_module_default())["accordion-faq-title"],
                children: title
            }),
            content.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Root */.fC, {
                    type: "single",
                    collapsible: true,
                    className: (styles_module_default())["accordion-container"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Item */.ck, {
                        value: "item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Header */.h4, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Trigger */.xz, {
                                    className: (styles_module_default()).trigger,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (styles_module_default())["trigger-label"],
                                        children: [
                                            item.headerText,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardRef, {
                                                className: (styles_module_default())["trigger-icon"]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Content */.VY, {
                                className: (styles_module_default()).content,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default())["content-wrapper"],
                                    children: item.children
                                })
                            })
                        ]
                    })
                }, item.headerText))
        ]
    });
};
/* harmony default export */ var website_accordion_faq = ((/* unused pure expression or super */ null && (WebsiteAccordionFAQ)));


/***/ }),

/***/ 25352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ WebsiteSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55351);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



const WebsiteSeo = (param)=>{
    let { seo  } = param;
    const websiteUrl = "https://olby.com";
    const { asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const asPathWithoutParams = asPath.split("?")[0];
    const canonical = websiteUrl + asPathWithoutParams;
    const websiteSeo = {
        canonical,
        ...seo
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        ...websiteSeo
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebsiteSeo);


/***/ }),

/***/ 81606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ TalentNewsletterSections; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _newsletter_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45169);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86829);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);




const TalentNewsletterSections = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((_, ref)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["section-wrapper"]),
        ref: ref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                    children: [
                        "Join our ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().highlight),
                            children: "newsletter"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().description),
                    children: "International career content straight to your inbox"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_newsletter_forms__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().form)
                })
            ]
        })
    });
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (TalentNewsletterSections)));


/***/ }),

/***/ 31483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C4": function() { return /* binding */ FAQLayout; }
});

// UNUSED EXPORTS: FAQLayoutPage, default

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/link/link.tsx
var link_link = __webpack_require__(946);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/shared-components/src/components/internal-sidebar-navigation/index.module.scss
var index_module = __webpack_require__(91757);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ../../libs/shared-components/src/components/internal-sidebar-navigation/index.tsx




const InternalSidebarNavigation = (param)=>{
    let { className , links , hasIconButtons =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            children: links.map((link)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: link.href,
                        className: classnames_default()((index_module_default()).link, {
                            [(index_module_default()).active]: link.isActive,
                            [(index_module_default())["with-quantity"]]: link.quantity
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()({
                                    [(index_module_default())["visually-hidden"]]: hasIconButtons
                                }),
                                children: link.label
                            }),
                            link.quantity && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (index_module_default()).badge,
                                children: link.quantity
                            })
                        ]
                    })
                }, link.label))
        })
    });
};
/* harmony default export */ var internal_sidebar_navigation = ((/* unused pure expression or super */ null && (InternalSidebarNavigation)));

// EXTERNAL MODULE: ../../libs/website-components/src/lib/layouts/website-layout/index.tsx + 9 modules
var website_layout = __webpack_require__(46087);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-update-header.tsx
var use_update_header = __webpack_require__(41898);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/utils/constants.ts + 14 modules
var constants = __webpack_require__(68579);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-clean-header.tsx
var use_clean_header = __webpack_require__(90573);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/talent/newsletter/index.tsx
var newsletter = __webpack_require__(81606);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/layouts/faq-layout/styles.module.scss
var styles_module = __webpack_require__(46801);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/layouts/faq-layout/index.tsx











const FAQLayout = (param)=>{
    let { children  } = param;
    const router = (0,next_router.useRouter)();
    const faqRef = (0,react.useRef)(null);
    const newsletterRef = (0,react.useRef)(null);
    const { asPath  } = router;
    const links = [
        {
            href: "/faq/talent",
            label: "For talent",
            isActive: asPath.includes("/faq/talent")
        },
        {
            href: "/faq/companies",
            label: "For companies",
            isActive: asPath.includes("/faq/companies")
        }
    ];
    (0,use_update_header/* useUpdateHeader */.G)(faqRef, constants/* HEADER_THEMES.NEUTRAL_BACKGROUND */._.NEUTRAL_BACKGROUND);
    (0,use_update_header/* useUpdateHeader */.G)(newsletterRef, constants/* HEADER_THEMES.EXT_DEEP_BLUE */._.EXT_DEEP_BLUE);
    (0,use_clean_header/* useCleanHeader */._)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["faq-layout-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: (styles_module_default())["faq-section"],
                    ref: faqRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (styles_module_default())["faq-title"],
                            children: "Frequently Asked Questions"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (styles_module_default())["support-text"],
                            children: [
                                "Don't see what you're looking for?",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.rU, {
                                    className: (styles_module_default())["support-link"],
                                    size: "large",
                                    href: "/contact-us",
                                    prefetch: false,
                                    children: "Contact us"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default())["faq-content"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalSidebarNavigation, {
                                    links: links
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default())["content-wrapper"],
                                    children: children
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter/* TalentNewsletterSections */.w, {
                ref: newsletterRef
            })
        ]
    });
};
const FAQLayoutPage = (page)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(website_layout/* default */.ZP, {
        children: page
    });
FAQLayout.getLayout = FAQLayoutPage;
/* harmony default export */ var faq_layout = ((/* unused pure expression or super */ null && (FAQLayout)));


/***/ }),

/***/ 59798:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content-text":"styles_content-text__trNut","theme--light":"styles_theme--light__v4wBC","theme--dark":"styles_theme--dark__SCUaK","link":"styles_link__z_JzD","fade-in-up":"styles_fade-in-up__kEaOR","fade-in-opacity":"styles_fade-in-opacity__3Mp2T","fade-in-up-opacity":"styles_fade-in-up-opacity__OHEii","fade-out-opacity":"styles_fade-out-opacity__7Iqp3","fade-out-left":"styles_fade-out-left__aAmsp"};

/***/ }),

/***/ 91757:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden":"internal-sidebar-navigation_visually-hidden__8Qxza","link":"internal-sidebar-navigation_link__Exjor","theme--light":"internal-sidebar-navigation_theme--light__7seGI","theme--dark":"internal-sidebar-navigation_theme--dark__4Q_u2","active":"internal-sidebar-navigation_active__UrlTJ","with-quantity":"internal-sidebar-navigation_with-quantity__QuFaZ","badge":"internal-sidebar-navigation_badge__TrmEE","fade-in-up":"internal-sidebar-navigation_fade-in-up__KxIdd","fade-in-opacity":"internal-sidebar-navigation_fade-in-opacity___RQkk","fade-in-up-opacity":"internal-sidebar-navigation_fade-in-up-opacity__80Xga","fade-out-opacity":"internal-sidebar-navigation_fade-out-opacity__7b403","fade-out-left":"internal-sidebar-navigation_fade-out-left___bQhu"};

/***/ }),

/***/ 59258:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordion-faq-title":"styles_accordion-faq-title__His_h","theme--light":"styles_theme--light__zmMUO","theme--dark":"styles_theme--dark__77BUU","accordion-container":"styles_accordion-container__68OBs","trigger-icon":"styles_trigger-icon__rp1eM","trigger":"styles_trigger__Dqre9","trigger-label":"styles_trigger-label__5oOow","content":"styles_content__y_Dk2","content-wrapper":"styles_content-wrapper__VUP8X","fade-in-up":"styles_fade-in-up__5Dk69","fade-in-opacity":"styles_fade-in-opacity__qYoXr","fade-in-up-opacity":"styles_fade-in-up-opacity__D9YZs","fade-out-opacity":"styles_fade-out-opacity__k21KZ","fade-out-left":"styles_fade-out-left___IZiF"};

/***/ }),

/***/ 86829:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section-wrapper":"newsletter_section-wrapper__6Wcri","theme--light":"newsletter_theme--light__bDCNk","theme--dark":"newsletter_theme--dark__78dKy","content":"newsletter_content__JeUPp","title":"newsletter_title__XfOmS","highlight":"newsletter_highlight__s307c","description":"newsletter_description__7LvNe","form":"newsletter_form__qd8ZV","fade-in-up":"newsletter_fade-in-up__3PcUI","fade-in-opacity":"newsletter_fade-in-opacity__k8xlF","fade-in-up-opacity":"newsletter_fade-in-up-opacity__0BfOD","fade-out-opacity":"newsletter_fade-out-opacity__8ULql","fade-out-left":"newsletter_fade-out-left__4dfDv"};

/***/ }),

/***/ 46801:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faq-layout-container":"styles_faq-layout-container__IGHAh","faq-section":"styles_faq-section__LY_0j","faq-title":"styles_faq-title__VHN_4","theme--light":"styles_theme--light__okM4K","theme--dark":"styles_theme--dark__MPYDk","support-text":"styles_support-text__5lZZ5","support-link":"styles_support-link__Bxb53","faq-content":"styles_faq-content__rr9Y2","content-wrapper":"styles_content-wrapper__Lbu8i","fade-in-up":"styles_fade-in-up__SWWlM","fade-in-opacity":"styles_fade-in-opacity___SfJr","fade-in-up-opacity":"styles_fade-in-up-opacity__h7bTJ","fade-out-opacity":"styles_fade-out-opacity__TXssC","fade-out-left":"styles_fade-out-left__yPk1k"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [350,82,955,474,691,559,169,656,774,888,179], function() { return __webpack_exec__(43130); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);